import axios from 'axios';

const API_URL = `${process.env.REACT_APP_API_URL || 'http://admin.local.dev:8080'}/api`;

/**
 * Service pour les appels API Platform (super admin)
 */
class PlatformService {
  /**
   * Récupère les données du dashboard
   * @returns {Promise<Object>} Données du dashboard
   */
  async getDashboard() {
    try {
      const response = await axios.get(`${API_URL}/platform/dashboard`);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la récupération du dashboard:', error);
      throw error;
    }
  }
}

export default new PlatformService();
